import { FormikErrors } from "formik";

type FieldError = {
  field: string;
  message: string;
};

export const extractFormikErrors = <T>(
  obj: FormikErrors<T>,
  parentKey = ""
): FieldError[] => {
  const errors: FieldError[] = [];

  for (const key in obj) {
    const path = parentKey ? `${parentKey}.${key}` : key;
    const value = obj[key];

    if (typeof value === "object" && value !== null) {
      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          const nestedPath = `${path}[${index}]`;
          const nestedErrors = extractFormikErrors(item, nestedPath);
          errors.push(...nestedErrors);
        });
      } else {
        const nestedErrors = extractFormikErrors(value, path);
        errors.push(...nestedErrors);
      }
    } else {
      if (typeof value === "string") {
        errors.push({ field: path, message: value });
      }
    }
  }

  return errors;
};
